export default {
  'pages.common.save': 'Save',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'OK',
  'pages.common.ok': 'OK',
  'pages.common.delete': 'Delete',
  'pages.common.edit': 'Edit',
  'pages.common.add': 'Add',
  'pages.common.append': 'Add',
  'pages.common.search': 'Search',
  'pages.common.reset': 'Reset',
  'pages.common.submit': 'Submit',
  'pages.common.back': 'Back',
  'pages.common.close': 'Close',
  'pages.common.export': 'Export',
  'pages.common.import': 'Import',
  'pages.common.refresh': 'Refresh',
  'pages.common.detail': 'Details',
  'pages.common.copy': 'Copy',
  'pages.common.operation': 'Actions',
  'pages.common.view': 'View',
  'pages.common.download': 'Download',
  'pages.common.upload': 'Upload',
  'pages.common.yes': 'Yes',
  'pages.common.no': 'No',
  'pages.common.loading': 'Loading…',
  'pages.common.more': 'More',
  'pages.common.all': 'All',
  'pages.common.createSuccess': 'Created successfully',
  'pages.common.saveSuccess': 'Saved',
  'pages.common.deleteSuccess': 'Deleted',
  'pages.common.deleteFailed': 'Delete failed',
  'pages.common.saveFailed': 'Save failed',
  'pages.common.loadFailed': 'Failed to load',
  'pages.common.requiredField': 'This field is required',
  'pages.common.selectedCount': 'Selected {count} item(s)',
  'pages.common.clearSelection': 'Clear selection',
  'pages.common.totalRecords': '{total} records in total',
  'pages.common.batchDeleteCount': 'Batch delete ({count})',
  'pages.common.statusSuccess': 'Success',
  'pages.common.statusFailed': 'Failed',
  'pages.common.timeRangeStart': 'Start time',
  'pages.common.timeRangeEnd': 'End time',
  'pages.common.unnamed': 'Unnamed',
  'pages.common.operationFailedRetry': 'Operation failed. Please try again.',
  'pages.common.batchDeleteSuccess': 'Batch delete succeeded',
  'pages.common.batchDeleteFailed': 'Batch delete failed. Please try again.',
  'pages.common.nItemsFailed': '{count} item(s) failed',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
